module.exports = __webpack_public_path__ + "static/media/LancamentosFinanceiros3.e2eb63a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancLancamentosFinanceiros/LancamentosFinanceiros3.png
// module id = 2152
// module chunks = 0